<span class="cdk-visually-hidden" #updateAvailable i18n="@@sk-updateAvailable">Update Available</span>
<span class="cdk-visually-hidden" #reload i18n="@@sk-reload">Reload</span>
<ng-container>{{translate(updateAvailable.innerHTML, reload.innerHTML)}}</ng-container>


<router-outlet></router-outlet>
